import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header/Header";
import Footer from "./Footer/Footer";
// import Sidebar from "./Sidebar/Sidebar";

const Layout = () => {
  const [pageTitle, setPageTitle] = React.useState("");
  const [pageSubtitle, setPageSubtitle] = React.useState("");
  return (
    <>
      <Header title={pageTitle} subtitle={pageSubtitle} />
      {/* <div className="mx-auto max-w-[1536px] p-4 pb-20 md:p-6 md:pb-6"> */}
      <div className="flex-1">
        <Outlet context={{ setPageTitle, setPageSubtitle }} />
      </div>
      <Footer/>
    </>
  );
};

export default Layout;
